module.exports = __webpack_public_path__ + "img/head.ede10558.jpg";